import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  templateUrl: './wk-image-preview.dialog.html',
  styleUrls: ['./wk-image-preview.dialog.scss'],
  standalone: false,
})
export class WkImagePreviewDialogComponent implements OnInit {
  imageSrc: string;
  imgAltTxt: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) private readonly matDialogData,
    readonly dialogRef: MatDialogRef<WkImagePreviewDialogComponent>
  ) {}

  ngOnInit(): void {
    this.imageSrc = this.matDialogData.imageDetails.src;
    this.imgAltTxt = this.matDialogData.imageDetails.altTxt;
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
